<template>
    <div class="group_person">
        <div v-if="headList" v-for="(item, index) in headList" :key="index">
            <img :src="item" alt="">
        </div>
    </div>
</template>

<script>
export default {
  name: "group_person",
  props:{
    headList: Array,
  },  
  components: {},
  created: function() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.group_person {
  display: flex;
  justify-content: center;
  > div {
    background: url(https://appd.knowbox.cn/ss/activity/group-buy/null-photo.png)
      no-repeat;
    background-size: 100% 100%;
    width: 0.86rem;
    height: 0.86rem;
    border-radius: 0.86rem;
    margin-left: 0.13rem;
    margin-right: 0.13rem;
    img {
      width: 0.86rem;
      height: 0.86rem;
      border-radius: 0.86rem;
    }
    &:nth-child(1) {
      position: relative;
      &::after {
        position: absolute;
        bottom: -0.02rem;
        left: 0.06rem;
        content: "团长";
        display: block;
        width: 0.76rem;
        height: 0.31rem;
        line-height: 0.31rem;
        text-align: center;
        background-color: #75c9ff;
        border-radius: 0.15rem;
        font-family: PingFangSC-Medium;
        font-size: 0.22rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }
}
</style>